import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import ANALYTICS_CATEGORIES from '../../analytics/categories';
import { Content } from '../../components/shared/Content';
import ScrollToTop from '../../components/shared/ScrollToTop';
import AccountListCrossBorderPayment from '../../components/transaction/CrossBorderPayment/AccountListCrossBorderPayment';
import CategoryList from '../../components/transaction/CrossBorderPayment/CategoryList';
import CrossBorderAmountFields from '../../components/transaction/CrossBorderPayment/CrossBorderAmountFields';
import NettbankAmountFields from '../../components/transaction/CrossBorderPayment/NettbankAmountFields/NettbankAmountFields';
import CrossBorderReceiverDetails from '../../components/transaction/CrossBorderPayment/Receiver/CrossBorderReceiverDetails';
import NewCrossBorderReceiver from '../../components/transaction/CrossBorderPayment/Receiver/NewCrossBorderReceiver';
import NewCrossBorderReceiverList from '../../components/transaction/CrossBorderPayment/Receiver/NewCrossBorderReceiverList';
import SummaryPage from '../../components/transaction/CrossBorderPayment/Summary/SummaryPage';
import crossBorderPaymentReducer from '../../components/transaction/CrossBorderPayment/form/reducer';
import { crossBorderPaymentInitialState } from '../../components/transaction/CrossBorderPayment/form/state';
import { CrossBorderFormContext } from '../../components/transaction/CrossBorderPayment/form/useFormContext';
import useValidate from '../../components/transaction/CrossBorderPayment/form/validate';
import { SigningContextProvider } from '../../signingContext/signingContext';

import './CrossBorderPayment.scss';

const CrossBorderPayment: React.FC = () => {
    return (
        <Content className="cross-border-payment">
            <SigningContextProvider analyticsCategory={ANALYTICS_CATEGORIES.CROSSBORDER_PAYMENT}>
                <CrossBorderFormContext
                    validateHook={useValidate}
                    reducer={crossBorderPaymentReducer}
                    initialState={{ ...crossBorderPaymentInitialState }}
                >
                    <Router>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/mottaker-liste" Component={NewCrossBorderReceiverList} />
                            <Route path="/mottaker" Component={CrossBorderReceiverDetails} />
                            <Route path="/mottaker-land" Component={NewCrossBorderReceiver} />
                            <Route path="/nettbank-belop" Component={NettbankAmountFields} />
                            <Route path="/belop" Component={CrossBorderAmountFields} />
                            <Route path="/kategorier" Component={CategoryList} />
                            <Route path="/oppsummering" Component={SummaryPage} />
                            <Route path="/" Component={AccountListCrossBorderPayment} />
                        </Routes>
                    </Router>
                </CrossBorderFormContext>
            </SigningContextProvider>
        </Content>
    );
};

export default CrossBorderPayment;
